import React from "react";

const ChevronLeft = ({ fillColor = "currentColor", fillOpacity = "0.5" }) => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.7055 9.69817C13.7988 9.60626 13.8728 9.49673 13.9233 9.37596C13.9738 9.25519 13.9998 9.12559 13.9998 8.99467C13.9998 8.86376 13.9738 8.73416 13.9233 8.61339C13.8728 8.49262 13.7988 8.38309 13.7055 8.29117C13.5165 8.10461 13.2616 8 12.996 8C12.7305 8 12.4756 8.10461 12.2865 8.29117L9.32154 11.2312C9.21935 11.3325 9.13823 11.4531 9.08288 11.5859C9.02752 11.7188 8.99902 11.8613 8.99902 12.0052C8.99902 12.1491 9.02752 12.2916 9.08288 12.4244C9.13823 12.5573 9.21935 12.6778 9.32154 12.7792L12.2765 15.7092C12.4656 15.896 12.7207 16.0008 12.9865 16.0008C13.2524 16.0008 13.5075 15.896 13.6965 15.7092C13.7898 15.6173 13.8638 15.5077 13.9143 15.387C13.9648 15.2662 13.9908 15.1366 13.9908 15.0057C13.9908 14.8748 13.9648 14.7452 13.9143 14.6244C13.8638 14.5036 13.7898 14.3941 13.6965 14.3022L11.3785 12.0052L13.7055 9.69817Z"
      fill={fillColor}
      fillOpacity={fillOpacity}
    />
  </svg>
);

export default ChevronLeft;
